import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { WrittenAssignmentService } from "src/app/_services/written-assignment.service";
import { GetWrittenAssignmentRecords, GetWrittenAssignmentRecordsError, GetWrittenAssignmentRecordsSuccess, ViewWrittenAssignmentRecords } from "./written-assignment-record.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { LearnerLearningRecord } from "src/app/_models/LearnerLearningRecord";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";

@Injectable()
export class WrittenAssignmentRecordEffects {
  constructor(
    private actions$: Actions,
    private writtenAssignmentService: WrittenAssignmentService
  ){}

  public getWrittenAssignmentRecords$ = createEffect(() => 
    this.actions$.pipe(
      ofType(GetWrittenAssignmentRecords),
      switchMap((payload) => 
        this.writtenAssignmentService.getWrittenAssignmentRecords$(payload.courseId).pipe(
          map((result: LearnerLearningRecord[]) => {
            return GetWrittenAssignmentRecordsSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetWrittenAssignmentRecordsError({error: error}));
          })
        )
      )
    )
  );

  public viewWrittenAssignmentRecords$ = createEffect(() => 
    this.actions$.pipe(
      ofType(ViewWrittenAssignmentRecords),
      switchMap((payload) => 
        this.writtenAssignmentService.viewWrittenAssignmentRecords$(payload.courseId, payload.learnerId).pipe(
          map((result: LearnerLearningRecord[]) => {
            return GetWrittenAssignmentRecordsSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetWrittenAssignmentRecordsError({error: error}));
          })
        )
      )
    )
  );
}